// Fallback values for local development
const defaultConfig = {
  API_URL: 'http://localhost:3000/backend',
  ENVIRONMENT: 'development'
};

// Get config from runtime config or use default
export const getConfig = () => {
  return window.__RUNTIME_CONFIG__ || defaultConfig;
};

// Helper to get specific config values
export const getConfigValue = (key, defaultValue) => {
  const config = getConfig();
  return config[key] !== undefined && config[key] !== `PLACEHOLDER_${key}` 
    ? config[key] 
    : defaultValue;
};

// Export commonly used config values
export const API_URL = getConfigValue('API_URL', defaultConfig.API_URL);
export const ENVIRONMENT = getConfigValue('ENVIRONMENT', defaultConfig.ENVIRONMENT); 